import {httpsCallable} from "firebase/functions";
// @ts-ignore -- "FirebaseUtils" is resolved by the web bundler, not by tsc
import {functions} from "FirebaseUtils";
import LogService from "services/LogService.js";

/** Sign-in methods, spelled the way checkAuthProvider reports them. */
export type AuthProvider = "email" | "google" | "apple" | "facebook";

/**
 * Sign-in methods already registered for an email; [] when it is free, null when
 * the lookup failed — callers must let the submit through in that case, since
 * createUserWithEmailAndPassword stays the authority.
 */
export const getEmailProviders = async (email: string): Promise<AuthProvider[] | null> => {
  try {
    const callable = httpsCallable<{email: string}, Array<{provider: AuthProvider}>>(functions, "checkEmailProvider");
    const result = await callable({email});
    return (result.data || []).map((entry) => entry?.provider).filter(Boolean);
  } catch (error: any) {
    LogService.addErrorLogAsync("", "Error checking email provider: " + error.message, false, true);
    return null;
  }
};
